import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// api
import { getUserInfoFromMomthera } from "../../../services/apis/momthera/user";



function MomtheraMyPageModifyInstitution() {
    const navigate = useNavigate();

    const [instName, setInstName] = useState("");
    const [department, setDepartment] = useState("");

    async function getUserInfoFromMomtheraFromAPI() {
        try{
            const res = await getUserInfoFromMomthera();
            if(Math.floor(res.status/100)===2){
                setInstName(res.data.instName);
                setDepartment(res.data.department);
            }else{
                throw new Error();
            }
        }catch{
            setInstName("");
            setDepartment("");
        }
    }

    function handleDownloadFile() {
        const downloadURL = process.env.REACT_APP_MODIFY_DOC_URL_MOMTHERA;
        window.open(downloadURL, "_blank");
    }

    useEffect(()=>{
        getUserInfoFromMomtheraFromAPI();
    },[])

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_center_box_wrapper momthera__mypage__modifyPhone" style={{padding: '3.125rem 0 0',}}>
                <div className="title_wrapper">
                    <div className="title">기관정보 변경</div>
                    <div className="description">
                        재직증명서를 업로드하여 기관명과 부서명을 수정할 수 있습니다.<br/>
                        관리자가 확인 후 승인되면 정보가 수정됩니다.
                    </div>
                </div>
                <div className="signinLayout__wrapper" style={{backgroundColor: 'transparent', padding: '2.5rem 2.5rem'}}>
                    <div className="momthera__mypage__modifyInstitution__title">
                        현재 정보
                    </div>
                    <div className="momthera__mypage__modifyInstitution__content_box" style={{marginBottom: '1.875rem'}}>
                        <div className="momthera__mypage__modifyInstitution__content_item_wrapper">
                            <div className="momthera__mypage__modifyInstitution__content_box_item">
                                <span style={{fontWeight: '800'}}>기관명</span>
                                <span>{instName}</span>
                            </div>
                            <div className="momthera__mypage__modifyInstitution__content_box_item">
                                <span style={{fontWeight: '800'}}>부서명</span>
                                <span>{department}</span>
                            </div>
                        </div>
                    </div>
                    <div className="momthera__mypage__modifyInstitution__title">
                        기관명, 부서명 수정
                    </div>
                    <div className="momthera__mypage__modifyInstitution__content_box2">
                        개인정보 수정 양식서를 작성하여 digitalpharm@dgtpharm.com 로 메일 보내주세요.
                    </div>
                    <div className="signinLayout__wrapper__body__footer multiple">
                        <button
                            className="submitButton"
                            onClick={handleDownloadFile}
                        >
                            양식 다운로드
                        </button>
                    </div>
                </div>                
                <div className="signinLayout__wrapper__body__footer multiple">
                    <button
                        className="cancelButton"
                        onClick={()=>navigate("/dtx006/mypage")}
                    >
                        되돌아가기
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MomtheraMyPageModifyInstitution;